// extracted by mini-css-extract-plugin
export var discountCodeBubbleContainer = "_jo-0";
export var discountCodeInput = "_jo-1";